var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.168 3.83333H9.83463V5.41667H13.168C14.593 5.41667 15.7513 6.575 15.7513 8C15.7513 9.19167 14.9346 10.1917 13.8263 10.4833L15.043 11.7C16.4013 11.0083 17.3346 9.625 17.3346 8C17.3346 5.7 15.468 3.83333 13.168 3.83333ZM12.3346 7.16667H10.5096L12.1763 8.83333H12.3346V7.16667ZM0.667969 1.55833L3.25964 4.15C1.74297 4.76667 0.667969 6.25833 0.667969 8C0.667969 10.3 2.53464 12.1667 4.83464 12.1667H8.16797V10.5833H4.83464C3.40964 10.5833 2.2513 9.425 2.2513 8C2.2513 6.675 3.25964 5.58333 4.5513 5.44167L6.2763 7.16667H5.66797V8.83333H7.94297L9.83463 10.725V12.1667H11.2763L14.618 15.5L15.668 14.45L1.7263 0.5L0.667969 1.55833Z",
    fill: "#1F3864"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.de6693c604b4e8249bf77a15689e6bb0.svg";
export { ForwardRef as ReactComponent };